import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { results } from '../data/content';
export function ResultsSection() {
  return <section aria-labelledby="resultados" className="border-y border-line bg-canvasAlt" data-id="element-248" data-mp="urxitod651av">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-249" data-mp="14oa7u8xrqqza">
        <Reveal className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between" data-id="element-250" data-mp="14ninju9mgfob">
          <h2 id="resultados" className="font-display text-2xl md:text-3xl font-extrabold uppercase text-ink" data-id="element-251" data-mp="72cyb11d9vzh">
            Con este Mega Pack vas a poder:
          </h2>
          <p className="font-display text-sm font-bold uppercase text-accent" data-id="element-252" data-mp="gxej5kom0bw9">
            Sin buscar cada respuesta desde cero
          </p>
        </Reveal>

        <ul className="mt-5 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-253" data-mp="3kg7tlom3ckm7">
          {results.map((result, i) => <Reveal key={result} as="li" delay={i * 0.02} className="flex items-center gap-2.5 rounded-lg border border-line bg-surface px-3 py-2.5 text-sm font-medium text-ink" data-id="element-254" data-mp="3pd82s8e8m3hj" data-mpi={i}>
              <CheckIcon size={15} className="flex-shrink-0 text-success" strokeWidth={3} data-id="element-255" data-mp="ohakgtxz127u" />
              <span data-id="element-256" data-mp="jhfq2gezlui1">{result}</span>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}